<template>
  <div class="jc-bw-container">
    <div class="jc-page-top">
      <div class="jc-page-header">
        <h1>
          <i class="jc-icon-my-circle-bold"></i>{{$t('bandWidth.bd')}}
        </h1>
        <div class="jc-box-action">
          <a v-bind:href="Config.BANDWIDTH_SERVER_URL"
             target="_blank">{{$t('bandWidth.helpDoc',[$t('bandWidth.bd')])}}</a>
        </div>
      </div>
      <div class="jc-page-content">
        <div class="el-container-table">
          <!-- 表头操作 -->
          <div class="el-container-table-actionBar">
            <el-form class="el-box-table-search"
                     :inline="true"
                     @submit.native.prevent>
              <el-form-item>
                <el-select id="my-select"
                           v-model="searchKey"
                           @change="handleSearchChange"
                           class="search-select-width"
                           style="width:162px">
                  <el-option class="my-select-input"
                             v-for="item in searchParams"
                             :key="item.searchKey"
                             :label="item.searchLabel"
                             :value="item.searchKey"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-input :placeholder="searchPlaceholder[searchKey]"
                          v-model="searchValue"
                          @keyup.enter.native="handleSearch"
                          class="my-input" clearable @clear="handleSearch">
                  <el-button slot="append"
                             @click="handleSearch"
                             icon="el-icon-search"
                             class="search-icon"></el-button>
                </el-input>
              </el-form-item>
              <!-- tag -->
                <el-form-item>
                  <jcb-tag-filter :service-code="ServiceCodeConstant.CCS"
                                  :visible.sync="batchEditTagDialogVisible"
                                  :region-id="TagRegionID"
                                  @checkedTags="filterWithCheckedTags">
                  </jcb-tag-filter>
                </el-form-item>
              <el-form-item class="set-icon">
                <el-button icon="el-icon-setting"
                           class="el-button-icon"
                           @click="setCustom()"
                           :title="$t('merge.customList')"></el-button>
              </el-form-item>
              <el-form-item>
                <el-button icon="jc-icon-download"
                           class="el-button-icon"
                           @click="exportList()"
                           :title="$t('speechcraft.exportResourceList')"></el-button>
              </el-form-item>
            </el-form>
            <el-form class="el-table-actionBar-item"
                     :inline="true">
              <el-form-item>
                <el-button icon="jc-icon-refresh-line"
                           class="el-button-icon"
                           @click="updateList"
                           v-if="fliter_region.length"></el-button>
              </el-form-item>
              <el-form-item>
                <!-- <el-radio-group v-model="selectedRegion" @change="selectRegion">
                    <el-radio-group-advance :max-shown-count="5" more-trigger="click" :more-label="$t('text.moreNode')">
                      <el-radio-button v-for="room in fliter_region"
                                    :key="room.idcId"
                                    :label="room.idcId"
                        >{{ room.region }}</el-radio-button
                      >
                    </el-radio-group-advance>
                  </el-radio-group> -->
                  <el-select v-model="selectedRegion" @change="selectRegion" :placeholder="$t('placeholder.choose')">
                    <el-option
                      v-for="room in fliter_region"
                      :key="room.idcId"
                      :value="room.idcId"
                      :label="room.region">
                    </el-option>
                  </el-select>
              </el-form-item>
            </el-form>
          </div>
          <!-- 表格 -->
          <div class="el-container-table">
            <el-table :data="bandWidthList"
                      style="width: 100%"
                      ref="table"
                      v-loading="refreshloading"
                      :empty-text="tableEmptyTip"
                      @selection-change="handleSelectionChange"
                      @filter-change="changeFilter">
              <el-table-column
                  type="selection"
                  width="55">
                </el-table-column>
              <el-table-column prop="bandwidthId"
                                 key="bandwidthId"
                                 min-width="130"
                                 :label="$t('text.id')"
                                 v-if="customerInfo !== null && customerInfo['bandwidthId'].selected">
                  <template slot-scope="scope">
                    <a href="javascript:void(0)"
                       @click="showDetail(scope.row)"
                       class="a-link-text">{{scope.row.bandwidthId}}</a>
                  </template>
                </el-table-column>
              <el-table-column key="bandwidthName"
                               prop="bandwidthName"
                               min-width="100"
                               :label="$t('bandWidth.name')"
                               v-if="customerInfo !== null && customerInfo['bandwidthName'].selected">
                <template slot-scope="scope">
                  <a href="javascript:void(0)"
                     @click="showDetail(scope.row)">{{scope.row.bandwidthName}}</a>
                </template>
              </el-table-column>
              <el-table-column key="relatedIpArr"
                               prop="relatedIpArr"
                               :label="$t('speechcraft.relatedIP')"
                               v-if="customerInfo !== null && customerInfo['relatedIp'].selected">
                <template slot-scope="scope">
                  <div>
                    <div v-for="(item,index) in scope.row.relatedIpArr"
                         :key="index"
                         v-if="index < 2">{{item.cidrAddr}}</div>
                    <div v-if="scope.row.relatedIpArr.length >= 2">...</div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column key="lineTypeName"
                               prop="lineTypeName"
                               columnKey="lineType"
                               :label="$t('bandWidth.lineType')"
                               v-if="customerInfo !== null && customerInfo['lineType'].selected"
                               :filter-multiple="false"
                               :filtered-value="filtersValue.lineType"
                               :filters="filterList.lineType"
                               :filter-method="filtersLineType">
                <template slot-scope="scope">
                  <span v-if=" scope.row.lineTypeName !== ''">{{scope.row.lineTypeName}}</span>
                  <span v-else>--</span>
                </template>
              </el-table-column>

              <el-table-column key="chargeTypeName"
                               prop="chargeTypeName"
                               columnKey="chargeType"
                                :label="$t('bandWidth.chargeType')"

                               :filter-multiple="false"
                               :filtered-value="filtersValue.chargeType"
                               :filters="filterList.chargeType"
                               :filter-method="filterschargeType"
                               v-if="customerInfo !== null && customerInfo['chargeType'].selected">
                <template slot-scope="scope">
                  <span v-if=" scope.row.chargeTypeName !== ''">{{scope.row.chargeTypeName}}</span>
                  <span v-else>--</span>
                </template>
              </el-table-column>
              <!--合同/保底带宽（Mbps）-->
              <el-table-column key="bandwidth"
                               prop="bandwidth"
                               min-width="120"
                               :label="$t('bandWidth.contractMinBandwidth') + '（Mbps）'"
                               v-if="customerInfo !== null && customerInfo['bandwidth'].selected">
                <template slot-scope="scope">
                  <span v-if=" scope.row.bandwidth != 0">{{scope.row.bandwidth}}</span>
                  <span v-else>--</span>
                </template>
              </el-table-column>
              <el-table-column key="status"
                               prop="status"
                               :label="$t('text.status')"
                               v-if="customerInfo !== null && customerInfo['status'].selected">
                <template slot-scope="scope">
                  <span :class="statusMap[scope.row.status]">{{filter_status[scope.row.status]}}</span>
                </template>
              </el-table-column>
              <el-table-column :label="$t('text.tags')"
                              key="tags"
                              v-if="customerInfo !== null && customerInfo['tags'].selected"
                               min-width="120"
                              class-name="p-line-break">
                <template slot-scope="scope">
                  <p>{{scope.row.tagPairs | maybeEmpty}}</p>
                </template>
              </el-table-column>
              <!--操作-->
                <!-- <el-table-column key="operate"
                                    min-width="100"
                                 :label="$t('text.operate')">
                  <template slot-scope="scope">
                    <div style="display:flex">
                      <el-button type="text"
                                @click="clickOperateTag(scope.row)">
                        {{ $t('text.editTag') }}
                      </el-button>

                    </div>
                  </template>
                </el-table-column> -->
            </el-table>
          </div>
        </div>
      </div>
    </div>
    <div class="el-page-footer block el-container-table-actionBar"
         v-if="bandWidthList.length">
      <el-tooltip class="item" effect="dark" :content="$t('text.pleaseSelectResource')" :disabled="!!multipleSelection.length" :visible-arrow="false" placement="top">
        <el-button type="primary" class="margin-top-ten"  :disabled="!multipleSelection.length" @click="batchEditTag">{{$t('text.editTag')}}</el-button>
      </el-tooltip>
      <el-pagination @size-change="handleSizeChange"
                     @current-change="handleCurrentChange"
                     :current-page="currentPage"
                     :page-sizes="pageSizes"
                     :page-size="pageSize"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="totalItems">
      </el-pagination>
    </div>
    <custom :visible.sync="customVisible"
            v-if="customVisible"
            :optionArr="optionArr"
            :type="type"></custom>
    <jcb-tag-edit :visible.sync="editTagDialogVisible"
                  :service-code="ServiceCodeConstant.CCS"
                  :region-id="TagRegionID"
                  :resource-ids="resourceId"
                  @complete="updateList">
    </jcb-tag-edit>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash';
import custom from '../common/custom/Custom.vue';
import { ServiceCodeConstant } from '@/common/Constants';

const type = 'bandwidth';

export default {
  components: { custom },
  name: 'bandwidth',
  data () {
    return {
      filtersValue: {
        lineType: [],
        chargeType: []
      },
      refreshloading: false,
      bandWidthList: [],
      searchValue: '',
      searchKey: 'bandwidthName',
      searchParams: [
        {
          searchKey: 'bandwidthName',
          searchLabel: this.$t('bandWidth.name')
        },
        {
          searchKey: 'relatedIp',
          searchLabel: this.$t('bandWidth.relationPublicNetIp')
        }
      ],
      searchPlaceholder: {
        bandwidthName: this.$t('bandWidth.inputName'),
        relatedIp: this.$t('bandWidth.inputIp')
      },
      statusMap: {
        'abnormal': 'jc-status jc-status--orange',
        'normal': 'jc-status jc-status--green'
      },
      filter_status: {
        normal: this.$t('text.normal'),
        abnormal: this.$t('text.abnormal'),
      },
      currentPage: 1,
      totalItems: 0,
      selectedRegion: null,
      regionMap: [],
      fliter_region: [],
      pageSize: 20,
      pageSizes: [20, 50, 100],
      type,
      customVisible: false,
      initFlag: false,
      tableEmptyTip: this.$t('text.noSearch'),
      optionArr: [
        {
          label: this.$t('text.id'),
          value: 'bandwidthId'
        },
        { label: this.$t('bandWidth.name'), value: 'bandwidthName' },
        { label: this.$t('bandWidth.relationPublicNetIp'), value: 'relatedIp' },
        { label: this.$t('bandWidth.lineType'), value: 'lineType' },
        { label: this.$t('bandWidth.chargeType'), value: 'chargeType' },

        { label: `${this.$t('bandWidth.contractMinBandwidth')}（Mbps）`, value: 'bandwidth' },
        { label: this.$t('text.status'), value: 'status' },
        {
          // 标签
          label: this.$t('text.tags'),
          value: 'tags'
        }
        // {
        //   // 操作
        //   label: this.$t('text.operate'),
        //   value: 'operation'
        // }
      ],
      // 编辑标签组件是否显示
      editTagDialogVisible: false,
      // 批量编辑标签组件是否显示
      batchEditTagDialogVisible: true,
      resourceId: [],
      // 标签过滤后的资源ID
      filteredResourceIds: [],
      multipleSelection: [],
    };
  },
  created () {
    /*
    * 改变过滤方法
    * 可以在created里尝试调用一下
    * filterChange
    * 同样调用updateList */
    const query = this.$route.query;
    if (query.selectRoom !== undefined) {
      this.selectedRegion = query.selectRoom;
    }
    if (query.lineTypeConsole !== undefined) {
      this.filtersValue.lineType.push(query.lineTypeConsole);
    }
    this.getRegion();
    if (this.$store.state.customInfo[this.type] === null) {
      this.getCustomInfo();
    }
  },
  mounted () { },
  computed: {
    ServiceCodeConstant: () => ServiceCodeConstant,
    // vuex中获取自定义信息
    customerInfo () {
      return this.$store.state.customInfo[this.type];
    },

    // vuex中获取bandwidth状态
    filterList () {
      return this.$store.state.filter.filterList;
    },

    needRequireResource () {
      return !!this.selectedRegion;
    }
  },
  methods: {
    batchEditTag() {
      this.resourceId = [];
      this.multipleSelection.forEach((item) => {
        this.resourceId.push(item.bandwidthId);
      });
      this.editTagDialogVisible = true;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    clickOperateTag (data) {
      this.resourceId = [].concat([data.bandwidthId]);
      this.editTagDialogVisible = true;
    },
    /**
     **@disc: 根据标签对实例进行过滤
     */
    filterWithCheckedTags(filterTags, tagKeys, resourceIds) {
      console.log(filterTags, tagKeys, resourceIds);
      if (tagKeys.length !== 0) {
        this.filteredResourceIds = resourceIds;
      } else {
        this.filteredResourceIds = [];
      }
      this.updateList();
    },
    // 获取区域信息
    getRegion () {
      this.$api.getRegions({ all: 1, idcLine: this.GLOBAL.IDCLINE }).then((res) => {
        if (res.errno === 10000 && res.errmsg === 'OK') {
          if (res.data && res.data.idcs.length > 0 && res.data.idcs[0] != null) {
            const data = res.data.idcs;
            this.regionFormat(data);
            if (this.$route.query.selectRoom !== undefined) {
              this.$nextTick(() => {
                this.selectedRegion = this.$route.query.selectRoom;
              })
            } else if (res.data.idcs) {
              this.$nextTick(() => {
                this.selectedRegion = res.data.idcs[0].idc;
              })
            }
            this.$nextTick(() => {
              this.selectedRegion.length && this.selectRegion();
            })
          } else {
            this.fliter_region = [];
          }
        } else {
          this.$message.error(res.errmsg);
        }
      });
    },

    handleSearchChange () {
      this.searchValue = '';
    },

    // 获取自定义信息
    getCustomInfo () {
      const param = {
        pageKey: this.type
      };
      this.$api.getCustomInfo(param).then((res) => {
        if (res.errno === 10000 && res.data.customInfo) {
          this.$store.commit('GET_CUSTOMINFO', { value: res.data.customInfo, type: this.type });
        }
      });
    },

    regionFormat (data) {
      this.fliter_region = [];
      for (let i = 0; i < data.length; i++) {
        this.fliter_region.push({
          idcId: data[i].idc,
          region: data[i].idcName
        });
      }
    },

    // 跳转详情
    showDetail (row) {
      const routeData = this.$router.resolve({
        path: '/bandwidth/detail',
        query: { id: row.bandwidthId, idcId: row.idc }
      });
      window.open(routeData.href, '_blank');
    },

    // 获取带宽列表
    getBandWidth (params) {
      if (!this.needRequireResource) {
        return;
      }
      const dataParams = {
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
        idc: this.selectedRegion
      };
      const tempParams = params || dataParams;
      // 是否通过标签进行筛选
      if (this.filteredResourceIds.length) {
        tempParams.bandwidthId = this.filteredResourceIds.join(',');
      }
      this.refreshloading = true;
      this.$api.getBandWidthList(tempParams).then((res) => {
        if (res.errno === 10000 && res.errmsg === 'OK') {
          if (res.data && res.data.bandwidths.length > 0 && res.data.bandwidths[0] != null) {
            this.bandWidthList = cloneDeep(res.data.bandwidths);
            this.bandWidthList.forEach((item) => {
              item.tagPairs = '';
              if (item.tags !== undefined && item.tags.length > 0) {
                item.tags.forEach((tag) => {
                  item.tagPairs += `${tag.key}:${tag.value},`;
                });
                item.tagPairs = item.tagPairs.substring(0, item.tagPairs.length - 1);
              }
            });
            this.totalItems = res.data.totalCount;
            this.bandWidthListFormat(this.bandWidthList);
          } else {
            this.bandWidthList = [];
            this.totalItems = 0;
          }
        } else {
          this.$message.error(res.errmsg);
          this.bandWidthList = [];
          this.totalItems = 0;
        }
        this.initFlag = false;
      }).finally(() => {
        this.refreshloading = false;
        this.filteredResourceIds = [];
      });
    },

    bandWidthListFormat (data) {
      for (let i = 0; i < data.length; i++) {
        data[i].relatedIpArr = data[i].relatedIp;
      }
    },

    updateList (type) {
      if (!this.needRequireResource) {
        return;
      }
      // 切换区域清除条件刷新
      this.tableEmptyTip = this.$t('text.noSearch');
      if (type === 'refresh') {
        this.searchValue = '';
        this.initFlag = true;
        this.currentPage = 1;
        this.refreshloading = true;
        this.tableEmptyTip = this.$t('text.noSearch');
        this.$refs.table.clearFilter();
      }
      const params = {
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
        idc: this.selectedRegion,
        lineType: type !== 'all' ? this.$route.query.lineTypeConsole : ''
      };
      // 是否有模糊搜索
      if (this.searchValue.trim() != '' && this.searchKey != '') {
        this.tableEmptyTip = this.$t('text.hasSearch');
        params[this.searchKey] = this.searchValue;
      }
      Object.keys(this.filtersValue).forEach((key) => {
        if (this.filtersValue[key].length > 0) {
          params[key] = this.filtersValue[key][0];
        }
      });
      this.getBandWidth(params);
    },

    // 搜索
    handleSearch (usePage) {
      this.initFlag = true;
      this.currentPage = 1;
      this.updateList();
    },

    // 导出列表
    exportList () {
      if (!this.needRequireResource) {
        return;
      }
      let url = `/ccs-api/api/resource/exportBandwidths?idc=${this.selectedRegion}&all=1`;
      // 是否有搜索
      if (this.searchValue != '' && this.searchKey != '') {
        url += `&${this.searchKey}=${this.searchValue}`;
      }
      Object.keys(this.filtersValue).forEach((key) => {
        if (this.filtersValue[key].length > 0) {
          url += `&${key}=${this.filtersValue[key][0]}`;
        }
      });
      console.log(url);
      window.open(url, '_self');
    },

    // 自定义
    setCustom () {
      this.customVisible = true;
    },

    handleSizeChange (val) {
      this.pageSize = val;
      this.updateList();
    },

    handleCurrentChange (val) {
      this.currentPage = val;
      if (!this.initFlag) {
        this.updateList();
      }
    },

    selectRegion () {
      Object.keys(this.filtersValue).forEach((key) => {
        this.filtersValue[key] = [];
      });
      if (this.fliter_region.length > 0) {
        this.updateList('refresh');
      }
    },

    filtersLineType (value, row) {
      return true;
    },
    filterschargeType() {
      return true;
    },
    // 根据状态搜索
    changeFilter (filter) {
      this.currentPage = 1;
      Object.keys(filter).forEach((key) => {
        this.filtersValue[key] = filter[key];
      });
      // if (filter.lineType.length == 0) {
      //   this.updateList('all');
      // } else {
      this.updateList();
      // }
    },
  }
};
</script>
<style lang="scss">
@import "./BandWidth.scss";
</style>
<style lang="scss" scoped>
.jc-bw-container /deep/ .custom-container .jc-dialog.jc-dialog--small {
  width: 500px;
}
</style>



// WEBPACK FOOTER //
// src/components/bandWidth/BandWidth.vue